module.exports = __webpack_public_path__ + "static/img/logo.63e1d38e.svg";